import {Injectable} from '@angular/core';
import {ModeDataService} from './mode-data.service';
import {NavigationService} from '../core/navigation/navigation.service';
import {AuthService} from '../core/auth/auth.service';
import {EditorRegistryService} from '../diagram-render/mx-graph/editor/editor-registry.service';

@Injectable()
export class ModeManagerService {
  constructor(
    private modeDataSvc: ModeDataService,
    private authSvc: AuthService,
    private navSvc: NavigationService,
    private registry: EditorRegistryService
  ) {}

  public toggle() {
    if (this.modeDataSvc.isEditMode()) {
      // stops editing process
      const graph = this.registry.getGraph();

      if (graph) {
        graph.stopEditing(false);
      }

      this.goViewMode();
    } else if (this.authSvc.canEditDiagram()) {
      this.goEditMode();
    }
  }

  public goEditMode() {
    return this.navSvc.current(true);
  }

  public goViewMode() {
    return this.navSvc.current(false);
  }
}
